import { render, staticRenderFns } from "./Data.vue?vue&type=template&id=54ea0cfd&scoped=true"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"
import style0 from "./Data.vue?vue&type=style&index=0&id=54ea0cfd&prod&scoped=true&lang=css"
import style1 from "./Data.vue?vue&type=style&index=1&id=54ea0cfd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea0cfd",
  null
  
)

export default component.exports